import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import Contact from "../components/Contact";
import RghtnowMarketingHeader from "./RghtnowMarketingHeader";
import RghtnowMarketingFooter from "./RghtnowMarketingFooter";
import ScrollToTop from "react-scroll-to-top";
import "./rghtnow-pages.css";
const ContactPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* Header */}
      <RghtnowMarketingHeader active="contact" />

      {/* Contact */}
      <Contact />

      {/* Footer */}
      <RghtnowMarketingFooter />
    </>
  );
};

export default ContactPage;
